'use strict';
angular.module('newspaperPageDraftRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.editctr.newspaper.pageDraft', {
            url: '/pageDraft?paperid&banmianid&starttime&untiltime&dieciid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/newspaper/pageDraft/pageDraft_tpl.html',
                    controller: 'newspaperPageDraftCtrl',
                },
            },
        });
    },
]);
